const URL = {
  LOGIN: 'Auth/login',
  ME: 'Auth/CurrentUserInfo',
  LOGOUT: 'Auth/Logout',
  VALIDATE_SUPER_LOGIN: 'Auth/ValidateSuperTokenId',
  DELETE: 'Auth/DeleteUser',
  FORGOT_PASSWORD_EMAIL: 'Auth/SendForgotPasswordEmail',
  AUTH_CHANGE_PASSWORD_USER: 'Auth/ChangePassword',
  VERIFY_CHANGE_PASSWORD_CODE: 'Auth/VerifyChangePasswordCode',
  GET_USER_REPORT_BY_FILTER: 'Auth/GetUserReportById',
  REFRESH_TOKEN: 'Auth/refresh',
  SHOPS: 'Auth/Shops',
  SWITCH_SHOP: 'Auth/SwitchShop',
  INTERCOM_AUTH: 'intercom/authorize',
  INTERCOM_ARTICLES: 'intercom/articles',
  INTERCOM_ARTICLE_BY_ID: 'intercom/articles/{articleId}/course/{courseId}',
}

export default URL
